import React from 'react'

function ArrowLeft({ className }) {
  return (
    <div className={`pl-2 ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11 17l-5-5m0 0l5-5m-5 5h12" />
      </svg>
    </div>
  )
}

export default ArrowLeft;
